module.exports = __webpack_public_path__ + "static/img/oillight1.abcf9aec.png";